import React from 'react';

// The Information Hub content frame: a black-bordered box with its title
// sitting on the top border. Shared by the Hot Scams and MoSAIC PSYOPS pages.
const FramedPanel = ({ title, children, className = '' }) => (
  <div className={`relative border-2 border-black mt-10 ${className}`}>
    <h1 className="absolute -top-6 left-4 bg-white px-3 text-3xl xl:text-4xl font-bold text-black whitespace-nowrap">
      {title}
    </h1>
    {children}
  </div>
);

export default FramedPanel;
